export default ".your-svg-icon\n  fill: currentColor\n";